import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import usePaging from 'new/state/paging/repository/usePaging';
import useProbeAdapter from 'new/state/probe/adapter/useProbeAdapter';
import useProbe from 'new/state/probe/repository/useProbe';
import { useCallback } from 'react';
import useDbDataTypes from 'new/state/dbDataTypes/repository/useDbDataTypes';
import useApp from 'new/state/app/repository/useApp';
import createFlowService from 'new/components/flows/service/createFlowService';
import useSchemas from 'new/state/dataSetSchemas/useSchemas';
import useForms from 'new/state/forms/repository/useForms';
import { PROBE_GET_SAMPLE_REQUEST } from 'js/constants/actionTypes';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';

export default function useDatabase(credentialId, selectedConnection, formType, flowType) {
  const org = useCurrentOrg();
  const { paging, getSourceConfigFields } = usePaging();
  const { requestConnectionTree, requestInitialDbTree, getProbeSample } = useProbeAdapter();
  const { setContextualSupport, unsetContextualSupport } = useApp();
  const isLoadingSample = useIsLoading(PROBE_GET_SAMPLE_REQUEST);
  const { updateFormData: updateData, data } = useForms(formType);

  const { getNexsetSchemaById } = useSchemas();
  const { loadDbDataTypes, getDbDataTypes } = useDbDataTypes();
  const { getProbeData } = useProbe();
  const flowService = createFlowService();
  const sourceConfigFields = getSourceConfigFields(selectedConnection, flowType);

  const onRequestProbeTree = useCallback(
    (root, folder) => {
      requestConnectionTree(credentialId, root, folder);
    },
    [requestConnectionTree, credentialId],
  );

  const onRequestInitialDbTree = useCallback(
    (info) => {
      requestInitialDbTree(credentialId, true, info);
    },
    [requestInitialDbTree, credentialId],
  );

  const onGetProbeSample = (sourceConfig) => () => {
    getProbeSample(credentialId, 0, sourceConfig);
  };

  const updateFormData = (formType, data) => {
    updateData(data);
  };

  const { dbDataTypes, schemaToDBDataTypes } = getDbDataTypes(selectedConnection) || {};

  return {
    org,
    data,
    paging,
    getProbeData,
    onRequestProbeTree,
    onRequestInitialDbTree,
    dbDataTypes,
    sourceConfigFields,
    getDataSchema: flowService.getSinkMappingAttributes,
    schemaToDBDataTypes,
    updateFormData,
    getDbDataTypes,
    loadDbDataTypes,
    onGetProbeSample,
    isLoadingSample,
    getNexsetSchemaById,
    setContextualSupport,
    unsetContextualSupport,
  };
}
